export const adWordsSendAdvertPageView = ({ id, make, model, price }, setDataLayer) => {
  try {
    const uahPrice = price.find(({ currency }) => currency === 'uah');

    ((...args) => setDataLayer(args))('event', 'page_view', {
      send_to: 'AW-855742650',
      dynx_itemid: id,
      dynx_itemid2: model && model.slug ? model.slug : '',
      dynx_itemid3: make && make.slug ? make.slug : '',
      dynx_itemid4:
        model && model.model_class && model.model_class.slug ? model.model_class.slug : '',
      dynx_pagetype: 'advert_page',
      dynx_totalvalue: uahPrice || '',
      user_id: 'replace with value',
    });
  } catch (e) {
    console.error('Failed to send an adwords event');
  }
};



// WEBPACK FOOTER //
// ./src/shared/helpers/adwordsEvents.js